import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-epmall/ordercomment/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-epmall/ordercomment/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-epmall/ordercomment/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-epmall/ordercomment/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-epmall/ordercomment/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-epmall/ordercomment/submit',
    method: 'post',
    data: row
  })
}


export const toogleStatus = (id) => {
  return request({
    url: '/api/park-epmall/ordercomment/tooglestatus/'+id,
    method: 'post',
    data: id
  })
}


